var $46ea6b3641b83e71$exports = {};
$46ea6b3641b83e71$exports = {
    "Empty": `\u{7A7A}`
};


export {$46ea6b3641b83e71$exports as default};
//# sourceMappingURL=ja-JP.module.js.map
